'use client';

import React, { useState } from 'react';

import { Bag } from '@depop/web-thrift-ui/Icons/Bag';
import { Badge } from '@depop/web-ui-kit/Badge';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { NavigationLink } from '../NavigationLink';
import { NavigationListItem } from '../NavigationListItem';

import styles from './styles.module.css';

import { QuickAccessBagPopover } from '@/components/Bag/QuickAccessBagPopover';
import { useBagBasic } from '@/modules/bag/useBagBasic';
import { useBagTracking } from '@/modules/bag/useBagTracking';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function NavigationQuickAccessBag() {
  const t = useTranslations('common');
  const pathname = usePathname();
  const { query: bagQuery } = useBagBasic();
  const [quickAccessBagAnchor, setQuickAccessBagAnchor] =
    useState<Element | null>(null);
  const [quickAccessBagTrigger, setQuickAccessBagTrigger] = useState(false);
  const [authenticated] = useCurrentUser();

  const bagTracking = useBagTracking();

  const isActive = pathname?.endsWith(`/bag/`);
  const count = bagQuery.data?.count || 0;

  function handleUnauthBagClick() {
    bagTracking.sendBagViewAction('nav');
  }

  function handleAuthBagClick() {
    bagTracking.sendBagViewAction('nav');
  }

  function handleBagNavClick() {
    if (authenticated) {
      handleAuthBagClick();
    } else {
      handleUnauthBagClick();
    }
  }

  return (
    <NavigationListItem>
      <div
        ref={setQuickAccessBagAnchor}
        onMouseEnter={() => setQuickAccessBagTrigger(true)}
        onMouseLeave={() => setQuickAccessBagTrigger(false)}
        onFocus={() => setQuickAccessBagTrigger(true)}
        onBlur={() => setQuickAccessBagTrigger(false)}
      >
        <NavigationLink
          onClick={handleBagNavClick}
          aria-label={t('Nav.Bag', { count })}
          isActive={isActive}
          as="/bag"
          href="/bag"
          rel="nofollow"
          className={styles.linkContainer}
        >
          <>
            <Bag size="lg" aria-hidden="true" />
            {Boolean(count) && (
              <Badge
                className={styles.badgeIcon}
                count={Number(count)}
                aria-hidden="true"
              />
            )}
          </>
        </NavigationLink>
      </div>
      <QuickAccessBagPopover
        anchor={quickAccessBagAnchor}
        anchorTrigger={quickAccessBagTrigger}
        mainAxisOffset={10}
      />
    </NavigationListItem>
  );
}
